import { parser } from './parser.js';
import { filterFieldStyleTags } from '../decorations/highlight.js';

/** @internal */
export const filterFieldParser = parser.configure({
  props: [filterFieldStyleTags],
});
